/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseDocumentDataExtractionFinancial = dynamic(
  () => import('../tasks/TaskResponseDocumentDataExtractionFinancial'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

// export const instruction = 'Instantly classify and extract invoice fields at 99% accuracy.';

export const responseCode = `{
  output: {
   "attributes":{
      "season":{
         "values":[
            "Spring"
         ]
      },
      "dress_style":{
         "values":[
            "Formal Dress"
         ]
      },
      "pattern":{
         "values":[
            "floral"
         ]
      },
      "sleeve_style":{
         "values":[
            "Sleeveless"
         ]
      }
   }
}`;

export const code = `input:
curl --request POST \
     --url https://api.scale.com/v1/catalog/extract_attributes \
     --header 'accept: application/json' \
     --header 'authorization: Basic dGVzdF85NmUzYjllMWE1NzM0NDdhOGRlZjI2ZjBkOGNmNWI0Yzo=' \
     --header 'content-type: application/json' \
     --data '
{
     "product_name": "White Dress",
     "product_description": "Get your hands on this beautiful dress in time for Spring!",
     "primary_image_url": "sampleDress.jpg"
}
`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseDocumentDataExtractionFinancial howItWorks />;

export const result = <TaskResponseDocumentDataExtractionFinancial animate howItWorks />;
